import { render, staticRenderFns } from "./SocketSwitch.vue?vue&type=template&id=16e5a4d8&scoped=true&"
import script from "./SocketSwitch.vue?vue&type=script&lang=ts&"
export * from "./SocketSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./SocketSwitch.vue?vue&type=style&index=0&id=16e5a4d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e5a4d8",
  null
  
)

export default component.exports